<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div
    v-show="isActive"
    :id="`tab-panel-${index}`"
    class="tab-panel"
    role="tabpanel"
    :aria-labelledby="`tab-button-${index}`"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  inject: ["registerTab", "activeTab"],
  props: {
    header: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      index: null,
    };
  },
  computed: {
    isActive() {
      return this.activeTab() === this.index;
    },
  },
  created() {
    this.index = this.registerTab({ header: this.header });
  },
};
</script>

<style lang="scss" scoped>
.tab-panel {
  font-family: "voyado Text";
  font-size: 16px;
  color: #21211f;
}
</style>